import React from 'react';
import { MainLayout } from '../../../layouts';
import { PatientRegistrationQR } from '../../../sections';
import { useTranslation } from 'react-i18next';

export const QRRegistration = () => {
  const { t } = useTranslation();
  return (
    <MainLayout>
      <h1 className="font-medium">{t('patientRegistrationQR.title')}</h1>
      <div className="mt-8">
        <PatientRegistrationQR />
      </div>
    </MainLayout>
  );
};
